import { Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DataTableDirective } from 'angular-datatables';
import { PCodeServices } from '../../../../../shared/services/pcode.service';

@Component({
    selector: 'user-selector',
    templateUrl: './selector.component.html',
    standalone: false
})

export class UserSelectorComponent {

    @ViewChild(DataTableDirective) _dtElement: DataTableDirective;
    @ViewChild('listModal') listModal;

    @Output() userSelectionCallback: EventEmitter<any> = new EventEmitter();
    
    public _dtOptions: DataTables.Settings = {};
    public _showTable: boolean = false;

    public _searchForm: UntypedFormGroup = this.fb.group(
        {
            name: [null],
            email: [null]
        }
    );

    constructor(
        @Inject('BASE_URL') private _baseUrl: string,
        private pcodeServices: PCodeServices,
        private translateService: TranslateService,
        private fb: UntypedFormBuilder
    )
    {

    }

    showModal()
    {
        this.listModal.show();
        setTimeout(() =>
        {
            this.getList();
        }, 200);
    }

    // get users list
    getList() 
    {
        this._showTable = false;

        this._dtOptions = this.pcodeServices.initDatatable({
            Filters: this._searchForm.value,
            Url: this._baseUrl + 'api/users/users/getList',
            Order: [0, 'asc'],
            Columns:
                [
                    {
                        title: this.translateService.instant('Modules.Users.Applications.Users.List.Table.Status'), data: "status", width: "20", className: "all sts-col", render: (data, type, row) => {
                            if (data)
                                return '<i class="material-icons text-green">change_history</i>';
                            else
								return '<i class="material-icons text-red">clear</i>';
                        }
                    },
                    { title: this.translateService.instant('Modules.Users.Applications.Users.List.Table.Name'), data: 'name', className: 'all' },
                    { title: this.translateService.instant('Modules.Users.Applications.Users.List.Table.Email'), data: 'email', className: 'min-tablet' },
                    { title: this.translateService.instant('Modules.Users.Applications.Users.List.Table.Roles'), data: 'roles', className: 'min-tablet' },
                    {
                        title: '', data: 'id', className: 'all adv-col', width: '20', orderable: false, render: (data, type, row) => {
                            let actions_list = '';

                            // select
                            actions_list += '<a href="#" data-action="select" title="Seleziona questo utente" mat-ripple class="btn btn-primary btn-fab btn-fab-sm"><i class="material-icons">arrow_right_alt</i></a>';

                            return actions_list;
                        }
                    },
                ],
            RowCallback: (row: Node, data: any[] | object, index: number) => {
                const _self = this;

                // select
                $('[data-action="select"]', row).click(function (e) {
                    _self.userSelectionCallback.emit({
                        id: data['id'],
                        name: data['name'],
                        email: data['email'],
                        status: data['status'],
                    });
                    _self.listModal.hide();
                });
            },
            DrawCallback: (settings: DataTables.SettingsLegacy) => {
                
            }
        });

        setTimeout(() => { this._showTable = true }, 0);
    }

    // search user
    search() {
        this.getList();
    }
}